import type { Ref } from 'react';
import type { Types } from '@marriott/mi-ui-library';

export type List = {
  brandtag: string;
  openinanewtab: boolean;
  linkurl: string;
  linkText: string;
};

export type LinkLists = {
  linklists: List[];
  categorylabel: string;
};

export interface BrandRibbonProps {
  componentId?: string;
  enableScrollingBehavior?: boolean;
  variations?: BrandRibbonVariation;
  brandLogoTag?: string;
  logoLinkText?: string;
  ctaLink?: string;
  categorylists: LinkLists[];
  trackingProperties?: Types.TrackingPropsInterface;
  styleclass?: string;
  cqPath?: string;
  forwardedRefs?: Ref<HTMLAnchorElement | null>[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model?: any;
}

export enum BrandRibbonVariation {
  PortfolioCollection = 'portfolioribbon',
  PortfolioBrands = 'portfoliobrands',
}
